let api={
  //印章柜相关
	cmy_cabinets_devicecabinets_findList: '/cabinets/devicecabinets/findList', //查询印章柜列表
  cmy_auth_user_getUsersByOrg:'/auth/user/getUsersByOrg',//查询印章柜管理人列表
  // cmy_auth_org_getOrganizational:'/auth/org/getOrganizational',//查询组织机构树
  cmy_cabinets_devicecabinets_add:'/cabinets/devicecabinets/add',//添加印章柜列表数据
  cmy_cabinets_devicecabinets_delete:'/cabinets/devicecabinets/delete',//删除印章柜列表数据
  cmy_cabinets_devicecabinets_update:'/cabinets/devicecabinets/update',//编辑印章柜列表数据
  cmy_entrance_deviceEntrance_findPassword:'entrance/deviceEntrance/findPassword',//印章柜查看密码
  cmy_auth_department_getLevelsByOrgForAddAndUpdateEmployee:'/auth/department/getLevelsByOrgForAddAndUpdateEmployee',//查询组织机构树
  cmy_cabinets_devicecabinetsface_findList:'/cabinets/devicecabinetsface/findList',//查寻人员认证列表
  cmy_cabinets_devicecabinetsface_delete:'/cabinets/devicecabinetsface/delete',//删除人员列表数据
  cmy_cabinets_devicecabinets_treeNode:'/cabinets/devicecabinets/treeNode',//查询印章柜与抽屉数
  cmy_cabinets_devicecabinets_deviceTree:'/cabinets/devicecabinets/deviceTree',//印章组织树
   cmy_cabinets_devicecabinets_findDeviceList:'/cabinets/devicecabinets/findDeviceList',//查询印章柜设备列表
   cmy_cabinets_devicecabinets_addDevice:'/cabinets/devicecabinets/addDevice',//新增印章入柜
   cmy_cabinets_devicecabinets_writeTag:'/cabinets/devicecabinets/writeTag',//写入标签
   cmy_cabinets_devicecabinets_deleteDevice:'/cabinets/devicecabinets/deleteDevice',//印章入柜删除
   cmy_cabinets_devicecabinets_checkTag:'/cabinets/devicecabinets/checkTag',//核对标签
   cmy_cabinets_devicecabinets_updateDevice:'/cabinets/devicecabinets/updateDevice',//更新设备
   cmy_cabinets_devicecabinets_check:'/cabinets/devicecabinets/check',//盘点
   cmy_cabinets_deviceCabinetsUseRecords_findList:'/cabinets/deviceCabinetsUseRecords/findList',//存取记录表
   cmy_cabinets_deviceCabinetsCheckRecords_findList:'/cabinets/deviceCabinetsCheckRecords/findList',//盘存记录
   cmy_cabinets_devicecabinets_cabinetsStatistical:'/cabinets/devicecabinets/cabinetsStatistical',//印章柜统计
   cmy_cabinets_devicecabinets_drawerStatistical:'/cabinets/devicecabinets/drawerStatistical',//抽屉统计
   cmy_cabinets_devicecabinets_ipDetection:'/cabinets/devicecabinets/ipDetection',//ip链接检测
   cmy_applet_orgList:'/applet/orgList',//获取租户列表
   cmy_applet_addOrg:'/applet/addOrg',//添加租户
   cmy_applet_updateOrg:'/applet/updateOrg',//更新租户信息
   cmy_applet_syncData:'/applet/syncData',//同步数据
   cmy_entrance_deviceEntrance_deleteByIds:'/entrance/deviceEntrance/deleteByIds',//门禁管理删除
   cmy_entrance_deviceEntrance_findList:'/entrance/deviceEntrance/findList',//门禁管理查询
   cmy_entrance_deviceEntrance_updatePassword:'/entrance/deviceEntrance/updatePassword',//门禁修改密码
   cmy_entrance_deviceEntrance_save:'/entrance/deviceEntrance/save',//门禁管理新增
   cmy_entrance_deviceEntranceFace_deleteByIds:'/entrance/deviceEntranceFace/deleteByIds',//删除人脸
   cmy_entrance_deviceEntranceFace_remove:'/entrance/deviceEntranceFace/remove',//清空人脸
   cmy_entrance_deviceEntrance_update:'/entrance/deviceEntrance/update',//门禁管理更新
   cmy_entrance_deviceEntranceFace_findList:'/entrance/deviceEntranceFace/findList',//门禁人脸管理
   cmy_entrance_deviceEntranceRecords_findList:'/entrance/deviceEntranceRecords/findList',//门禁记录查询
   cmy_entrance_deviceEntranceFace_uploadFace:'/entrance/deviceEntranceFace/uploadFace',//门禁人脸上传
   cmy_entrance_deviceEntranceFace_findFaceList:'/entrance/deviceEntranceFace/findFaceList',//人脸库查询
   cmy_entrance_deviceEntranceFace_faceRelation:'/entrance/deviceEntranceFace/faceRelation',//人脸库关联
   cmy_entrance_deviceEntranceFace_relationList:'/entrance/deviceEntranceFace/relationList',//已关联列表
   cmy_device_scanner_findScannerAfterUsingCompareInfo:'/device/scanner/findScannerAfterUsingCompareInfo',//扫描对比详情
   cmy_device_scanner_findList:'/device/scanner/findList',//扫描记录列表
   cmy_application_application_pushAndUnlock:'/application/application/pushAndUnlock',//解锁用印

   cmy_auth_notice_tagRead:'/auth/notice/tagRead',//系统消息,标记已读
   //关键字管理
   cmy_param_findList:"/param/findList",//查询列表
   cmy_param_add:'/param/add',//新增
   cmy_param_update:'/param/update',//更新
   cmy_param_deleteByIds:'/param/deleteByIds',//删除
   cmy_entrance_deviceEntranceFace_updateById:'/entrance/deviceEntranceFace/updateById',//门禁管理开关
   cmy_device_signet_unlock:'/device/signet/unlock',

}
export default api



// WEBPACK FOOTER //
// ./src/api/cmy_api.js